import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { RiBillLine } from "react-icons/ri";

const CommissionInfo = ({ bidDetails }) => {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        boxShadow: "none",
        margin: "1vh 0",
        border: "1px solid #E5E7EB",
        overflow: "initial",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            marginBottom: "1vh",
            letterSpacing: "0",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <RiBillLine color="#4D6BF6" size={20} /> Commission Information
        </Typography>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "14px", color: "#666" }}>
            Initial Desposit By Contractor (%)
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            {bidDetails?.project_fees?.Initial_deposit_needed_by_contractor ||
              "-"}
          </span>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "14px", color: "#666" }}>
            Warranty withheld amount (%)
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            {bidDetails?.project_fees?.completion_of_the_warranty_period || "-"}
          </span>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "14px", color: "#666" }}>
            Reno Fees (%)
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            {bidDetails?.project_fees?.contractor_fees || "-"}
          </span>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "14px", color: "#666" }}>
            Warranty Period
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            {bidDetails?.project_fees?.warranty_period}{" "}
            {bidDetails?.project_fees?.warranty_period_unit
              ?.toLowerCase()
              ?.replace(/^\w/, (c) => c.toUpperCase())}
          </span>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "14px", color: "#666" }}>
            Handover percentage (%)
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            {bidDetails?.project_fees?.project_completion}{" "}

          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default CommissionInfo;
